module.exports = __webpack_public_path__ + "static/pic10.c6770d0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pics/pic10.jpg
// module id = 143
// module chunks = 159055269280251 263243624345932